module.exports = __webpack_public_path__ + "static/media/menu-signout.927ba627.svg";